import { BrandLink } from "./BrandLink";
import { ContactLink } from "../lib/contact";
import { useEffect, useState } from "react";
import { LogOut, ArrowLeft, UserRound, Plus, MoreVertical, FileArchive, Users } from "lucide-react";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { NotificationBell } from "./NotificationBell";
import { ExportSheet } from "./ExportSheet";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { markExplicitSignOut } from "../context/AuthContext";
import { useWallet } from "../hooks/useWallet";

export const AppHeader = ({ back }) => {
  const { wallet } = useWallet();
  const navigate = useNavigate();
  const [menu, setMenu] = useState(false);
  const [exportOpen, setExportOpen] = useState(false);
  useEffect(() => {
    if (!menu) return;
    const close = (e) => { if (!e.target.closest("[data-testid=header-menu],[data-testid=header-menu-button]")) setMenu(false); };
    document.addEventListener("pointerdown", close); return () => document.removeEventListener("pointerdown", close);
  }, [menu]);
  const unlimited = wallet?.subscription_status === "active";
  const readOnly = wallet?.subscription_status === "refunded_read_only";
  const pastDue = wallet?.subscription_status === "past_due";

  const logout = async () => { markExplicitSignOut(); await supabase.auth.signOut({ scope: "local" }); navigate("/auth", { replace: true }); };

  return (
    <>
      <header className="topbar">
        <div className="flex items-center gap-2">
          {back && <button type="button" className="icon-btn" onClick={() => navigate(back)} data-testid="back-button" aria-label="Back"><ArrowLeft size={18} /></button>}
          <BrandLink mark={!back} />
        </div>
        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          <button type="button" className={`balance-pill ${unlimited ? "balance-unlimited" : ""} ${readOnly ? "balance-readonly" : ""}`} onClick={() => navigate("/app/billing")} data-testid="balance-pill" aria-label="Buy credits" title="Buy credits">
            <span>{unlimited ? "Unlimited*" : wallet ? `${wallet.credit_balance} cr` : "—"}</span> <Plus size={14} strokeWidth={3} className="pill-plus" />
          </button>
          <NotificationBell />
          <div className="relative">
            <button type="button" data-testid="header-menu-button" className="icon-btn" onClick={() => setMenu((m) => !m)} aria-label="More" aria-haspopup="menu" aria-expanded={menu}><MoreVertical size={18} /></button>
            {menu && (
              <ul className="currency-menu" role="menu" data-testid="header-menu">
                <li><button type="button" role="menuitem" onClick={() => { setMenu(false); setExportOpen(true); }} data-testid="header-menu-export"><FileArchive size={14} /> Monthly export</button></li>
                <li><button type="button" role="menuitem" onClick={() => { setMenu(false); navigate("/app/crew"); }} data-testid="header-menu-crew"><Users size={14} /> Your crew</button></li>
                <li><button type="button" role="menuitem" onClick={() => { setMenu(false); navigate("/app/settings"); }} data-testid="settings-button"><UserRound size={14} /> Settings</button></li>
                <li><button type="button" role="menuitem" onClick={logout} data-testid="logout-button"><LogOut size={14} /> Log out</button></li>
              </ul>
            )}
          </div>
        </div>
      </header>
      {exportOpen && <ExportSheet onClose={() => setExportOpen(false)} />}
      {readOnly && <div className="banner-danger" data-testid="read-only-banner">Your account is read-only after a refund. Creating jobs and buying credits are disabled — contact us via Messenger: <ContactLink testid="read-only-contact-link" />.</div>}
      {pastDue && <div className="banner-warn" data-testid="past-due-banner">Payment failed — <button type="button" className="underline font-bold" onClick={() => navigate("/app/billing")} data-testid="past-due-fix">update your card</button> to keep Solo Pro.</div>}
    </>
  );
};
